import { formatSeconds } from '../../../../../utils/date';
import { MigrationBlockReason } from '../../../../utils/dataMigration';
import texts from './texts.json';

const BLOCK_REASON_TEXTS = {
  [MigrationBlockReason.CUSTOM_EXERCISE]: texts.blockReason.customExercise,
  [MigrationBlockReason.EDITED_EXERCISE]: texts.blockReason.editedExercise,
  [MigrationBlockReason.MISSING_EXERCISE]: texts.blockReason.missingExercise,
  [MigrationBlockReason.NON_BASE_EXERCISE]: texts.blockReason.nonBaseExercise,
};

const statusText = (row) => {
  if (row.isMigratable) {
    return texts.status.ready;
  }
  return BLOCK_REASON_TEXTS[row.blockReason] || texts.status.blocked;
};

const getColumns = ({ statusRenderCell }) => [
  {
    field: 'name',
    quickSearch: true,
    headerName: texts.columns.workoutName,
    flex: 40,
  },
  {
    field: 'estimatedDuration',
    headerName: texts.columns.duration,
    flex: 15,
    valueGetter: ({ row }) => (
      row.estimatedDuration ? formatSeconds(row.estimatedDuration) : texts.emptyCell
    ),
  },
  {
    field: 'status',
    headerName: texts.columns.status,
    flex: 30,
    /*
      The endpoint orders compliant workouts first and that order is the contract, so this
      column stays unsortable rather than offering a click that would scramble it.
    */
    sortable: false,
    valueGetter: ({ row }) => statusText(row),
    renderCell: statusRenderCell,
  },
];

export { BLOCK_REASON_TEXTS, statusText };

export default getColumns;
